import { render, staticRenderFns } from "./StickyBar.vue?vue&type=template&id=04c31af0&scoped=true&"
import script from "./StickyBar.vue?vue&type=script&lang=ts&"
export * from "./StickyBar.vue?vue&type=script&lang=ts&"
import style0 from "./StickyBar.vue?vue&type=style&index=0&id=04c31af0&lang=scss&scoped=true&"
import style1 from "./StickyBar.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c31af0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsImageOrFallback: require('/var/www/packages/theme/components/atoms/ImageOrFallback.vue').default,AtomsAddToCartButton: require('/var/www/packages/theme/components/atoms/AddToCartButton.vue').default,WrappersProductAddToCartText: require('/var/www/packages/theme/components/wrappers/ProductAddToCartText.vue').default,AtomsKEButton: require('/var/www/packages/theme/components/atoms/KEButton.vue').default,AtomsFavoriteButton: require('/var/www/packages/theme/components/atoms/FavoriteButton.vue').default})
